<template>
    <div class="checkout-order">
        <div class="container py-5">
            <div class="row">
                <div class="col-6 col-md-3">
                    <div class="checkout-order-item-wrap">
                        <div class="checkout-order-item-inner">
                            <a href="#" @click.prevent="chooseMorePhotosBtn"
                               class="checkout-order-item checkout-order-item--empty">
                                <span class="checkout-order-item--empty-inner">
                                    <span class="material-icon icon-add"/>
                                    <span class="checkout-order-item--empty-txt">{{ $t('choose_more_photos') }}</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md-3" v-for="(photo, i) in myOrder.photos" :key="i">
                    <div class="checkout-order-item-wrap">
                        <div class="checkout-order-item-inner" v-if="showItems">
                            <a href="#" @click.prevent="album && isEditableState ? showPhotoEditor(photo, sizes) : ''" :class="{'-disabled': album && !isEditableState}">
                                <processed-photo v-if="!_.find(hiddenPhotos, {id: photo.id})" :item="photo" :width="sizes.width" :height="sizes.height"/>
                            </a>
                            <div class="checkout-order-item-actions">
                                <template v-if="myOrder.photos.length > 1 && isDeletableState">
                                    <a href="#" :id="`remove-item-${i}`" :class="['checkout-order-item-action', {'checkout-order-item-action--txt checkout-order-item-action--icon-left': album && !isEditableState}]" @click.prevent="removePhoto(i)">
                                        <span class="material-icon icon-delete"/>
                                        <template v-if="album && !isEditableState">{{ $t('delete_photo') }}</template>
                                    </a>
                                    <template v-if="album && isEditableState">
                                        <b-tooltip placement="top" :target="`remove-item-${i}`">
                                            {{ $t('helpers.delete') }}
                                        </b-tooltip>
                                    </template>
                                </template>
                                <template v-if="album && isEditableState">
                                    <a href="#" :id="`edit-item-${i}`" :class="['checkout-order-item-action', {'checkout-order-item-action--txt checkout-order-item-action--icon-left': myOrder.photos.length === 1 || !isDeletableState}]" @click.prevent="showPhotoEditor(photo, sizes)">
                                        <span class="material-icon icon-create"/>
                                        <template v-if="myOrder.photos.length === 1 || !isDeletableState">{{ $t('edit_photo') }}</template>
                                    </a>
                                    <template v-if="myOrder.photos.length > 1 && isDeletableState">
                                        <b-tooltip placement="top" :target="`edit-item-${i}`">
                                            {{ $t('helpers.edit') }}
                                        </b-tooltip>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <counter v-if="myOrder && myOrder.product && myOrder.product.isDigital && !myOrder.product.isDownloadable"
                                 :index="getIndexById(photo.id)"
                                 :quantity="photo.quantity"
                                 action="SET_PHOTO_QUANTITY"
                                 class="m-auto"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Counter from '../Counter.vue';
  import ProcessedPhoto from '../ProcessedPhoto';

  import orderStep4 from 'src/mixins/orderStep4Component';

  export default {
    mixins: [orderStep4],
    components: {
      Counter,
      ProcessedPhoto,
    },
  };
</script>
